import React, { useMemo } from 'react';

import { useNESteps } from 'context/NEStepsContext';

import { InputField } from 'components/FormHelper/InputField';
import { LabelCheckbox } from 'components/LabelCheckbox/LabelCheckbox';
import {
  selectedTestSuiteValue,
  shouldFillNETestData,
} from 'components/NEForm/NETestdata/NETestSetup';

import { NE_ACTIVE_STEP, STORAGE_KEY } from 'global/constants';

import { getTestingAccountItemMap } from 'utils/FormUtils';
import { isProduction } from 'utils/StageUtils';
import { getTenantId } from 'utils/tenantUtil';

import './FormTestingBanner.sass';

export const NEFormTestingBanner = () => {
  const { activeStep } = useNESteps();

  const toggleTestSetup = () => {
    localStorage.setItem(STORAGE_KEY.FILL_NE_FORM, !shouldFillNETestData);
    window.location.reload();
  };

  const changeTestingAccount = (e) => {
    localStorage.setItem(STORAGE_KEY.NE_SELECTED_TEST_SUITE, e.target.value);
    window.location.reload();
  };

  const renderedTextForAlert = useMemo(
    () =>
      activeStep !== NE_ACTIVE_STEP.BRANCH_SELECTION
        ? 'Änderungen können durch den Tester vorgenommen werden.'
        : 'Es dürfen keine Änderungen vorgenommen werden.',
    [activeStep]
  );

  if (isProduction()) {
    return null;
  }

  const renderBannerContent = () => {
    if (activeStep === NE_ACTIVE_STEP.EMAIL_INPUT) {
      return (
        <div className="test-alert-container">
          <LabelCheckbox
            tooltipText="Für die Neueintragung wurden Testdaten hinterlegt. Diese können für den Testlauf genutzt werden. Dafür klicken Sie einfach auf die Checkbox und die Testdaten werden geladen und stehen Ihnen zur Auswahl bereit. Um manuell zu Testen, lassen Sie die Checkbox abgewählt. Bitte beachten Sie den Hinweisetext auf jeder Seite. Dieser gibt Auskunft darüber, ob Daten geändert werden dürfen oder nicht."
            value={shouldFillNETestData}
            name="testSetupNE"
            id="testSetupNE"
            onChange={toggleTestSetup}
            label="Testdaten laden?"
          />
          {shouldFillNETestData && (
            <div className="test-alert">
              <div className="test-alert__input-field">
                <InputField
                  fullWidth
                  select
                  items={getTestingAccountItemMap(getTenantId())}
                  label="Testfall wählen"
                  onChange={changeTestingAccount}
                  name="selectedTestAccount"
                  id="selectedTestAccount"
                  value={selectedTestSuiteValue}
                  oldValue=""
                />
              </div>
            </div>
          )}
        </div>
      );
    }
    if (shouldFillNETestData) {
      return (
        <div className="test-alert-container">
          <div>
            <span className="test-alert-bold">Geladene Testdaten: </span>
            {
              getTestingAccountItemMap(getTenantId()).find(
                (it) => it.value === selectedTestSuiteValue
              ).label
            }
          </div>
          <div>
            <span className="test-alert-bold">Bitte beachten: </span> {renderedTextForAlert}
          </div>
        </div>
      );
    }
    return null;
  };

  return <div className="test-container">{renderBannerContent()}</div>;
};
